import React from 'react';

interface TabsProps {
  setGallery: () => void;
  setBeforeAndAfter: () => void;
  gallerySwitch: boolean;
  hasBeforeAfter: boolean;
}

function Tabs({setGallery, setBeforeAndAfter, gallerySwitch, hasBeforeAfter}: TabsProps) {
  const active = "text-navy border-b-2 border-accent font-semibold";
  const inactive = "text-slate-400 hover:text-navy";

  return (
    <div className="flex justify-center gap-8 pt-4 pb-2 max-w-5xl mx-auto">
      <button className={`text-lg px-2 pb-2 transition-colors ${gallerySwitch ? active : inactive}`} onClick={setGallery}>
        Gallery
      </button>
      {hasBeforeAfter && (
        <button
          className={`text-lg px-2 pb-2 transition-colors ${!gallerySwitch ? active : inactive}`}
          onClick={setBeforeAndAfter}
        >
          Before & after
        </button>
      )}
    </div>
  );
}

export default Tabs;
